import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { from, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-successmodal',
  templateUrl: './successmodal.component.html',
  styleUrls: ['./successmodal.component.scss']
})
export class SuccessmodalComponent implements OnInit {

  constructor(
    private translateService: TranslateService
  ) { }


  @Input()
  modalDialogBodyContent = 'bodyContent';
  
  @Input()
  additionalModalDialogBodyContent: string;

  @Input()
  modalDialogType = 'BLOCK_TOAST';


  @Output() closeSuccessModalDialogEvent = new EventEmitter<boolean>();

  ngOnInit(): void {

    const myArray = [1, 2, 3, 4];
    from(myArray).pipe(
      concatMap(item => of(item).pipe(delay(3000)))
    ).subscribe(timedItem => {
      this.closeSuccessModalDialogEvent.emit(true);
    });

  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'close') {
      this.closeSuccessModalDialogEvent.emit(true);
    }
  }

}
